import React from 'react';
import styles from './styles.module.scss';
import { TooltipProvider } from 'src/Components/TooltipProviderV2';
import CheckoutProvider from './CheckoutProvider';
import HeroSaleProvider from './HeroSaleProvider';
import RentOutProvider from './RentOutProvider';
import RentProvider from './RentProvider';
import ItemDetailCard from './Components/ItemDetailCard';
import UserWalletProvider from '@profile/src/Profile_V2/UserWalletProvider';
import UnlockHeroProvider from './UnlockHeroProvider';
import MinHeroProvider from './MintHeroProvider';
import WalletConnectConfirmProvider from 'src/Components/WalletConnectConfirmProvider';
import { TestableProvider } from '@wolffun/testable-id';

const ItemDetailPage = () => {
  return /*#__PURE__*/React.createElement(TestableProvider, {
    testId: "hero-detail"
  }, /*#__PURE__*/React.createElement(WalletConnectConfirmProvider, null, /*#__PURE__*/React.createElement(TooltipProvider, null, /*#__PURE__*/React.createElement(UserWalletProvider, null, /*#__PURE__*/React.createElement(MinHeroProvider, null, /*#__PURE__*/React.createElement(UnlockHeroProvider, null, /*#__PURE__*/React.createElement(HeroSaleProvider, null, /*#__PURE__*/React.createElement(RentOutProvider, null, /*#__PURE__*/React.createElement(RentProvider, null, /*#__PURE__*/React.createElement(CheckoutProvider, null, /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(ItemDetailCard, null))))))))))));
};

export default ItemDetailPage;